// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"cd090b3c","744":"011c0824"}[chunkId] + ".chunk.js";
};